var map = {
	"./BNP_Samodzielniak_16_D_1.mp3": "5479",
	"./BNP_Samodzielniak_16_E_1.mp3": "be9d",
	"./BNP_Samodzielniak_16_F_1.mp3": "bb14",
	"./BNP_Samodzielniak_16_G_1.mp3": "14fd",
	"./BNP_Samodzielniak_16_H_1.mp3": "5149",
	"./BNP_Samodzielniak_16_I_1.mp3": "1bbe",
	"./BNP_Samodzielniak_16_J_1.mp3": "c98d",
	"./BNP_Samodzielniak_17_A_1.mp3": "ff3e",
	"./BNP_Samodzielniak_17_A_2.mp3": "7fc4",
	"./BNP_Samodzielniak_17_B_1.mp3": "0e32",
	"./BNP_Samodzielniak_17_B_2.mp3": "5a72",
	"./BNP_Samodzielniak_17_C_1.mp3": "318c",
	"./BNP_Samodzielniak_17_C_2.mp3": "b8ff",
	"./BNP_Samodzielniak_17_D_2.mp3": "f0b2",
	"./BNP_Samodzielniak_17_E_2.mp3": "e567",
	"./BNP_Samodzielniak_17_F_2.mp3": "f833",
	"./BNP_Samodzielniak_17_G_2.mp3": "bc57",
	"./BNP_Samodzielniak_17_H_2.mp3": "202f",
	"./BNP_Samodzielniak_17_I_2.mp3": "5607",
	"./BNP_Samodzielniak_17_J_2.mp3": "f9f1",
	"./BNP_Samodzielniak_17_K_1.mp3": "5ed1",
	"./BNP_Samodzielniak_17_K_2.mp3": "2afc",
	"./BNP_Samodzielniak_17_M_1.mp3": "e6c8",
	"./BNP_Samodzielniak_17_M_2.mp3": "729a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b544";